import { psAxios } from '@patsnap/common-ps-http';
import { DRAFTING_URI, FREE_DRAFTING_URI } from '@/constants/base-url';
import { headerService } from '@/services/header';

// 游客可访问的接口白名单（匹配 DRAFTING_URI 之后的路径，即 /api/...）
// 适配本地（http://localhost:8005/api/...）和远程（.../drafting/api/...）两种情况
const FREE_API_PATTERNS: RegExp[] = [
    // projects
    /^\/api\/projects\/data\/[^/?]+/,
    /^\/api\/projects\/list/,
    /^\/api\/projects\/recent/,
    /^\/api\/projects\/stats/,
    /^\/api\/projects\/filters/,
    /^\/api\/projects\/transfer_ownership/,
    /^\/api\/projects\/[^/?]+\/detail/,
    /^\/api\/projects\/[^/?]+\/result/,
    /^\/api\/projects\/[^/?]+\/status/,
    /^\/api\/projects\/[^/?]+\/resource-stats/,
    // folders
    /^\/api\/folders\/list/,
    /^\/api\/folders\/tree/,
    // templates（具体路径在前）
    /^\/api\/templates\/meta\/stats/,
    /^\/api\/templates\/list/,
    /^\/api\/templates\/[^/?]+/,
    // instructions（具体路径在前）
    /^\/api\/instructions\/meta\/enums/,
    /^\/api\/instructions\/list/,
    /^\/api\/instructions\/[^/?]+/,
    // writing-styles（具体路径在前）
    /^\/api\/writing-styles\/list/,
    /^\/api\/writing-styles\/stats/,
    /^\/api\/writing-styles\/[^/?]+/,
    // attachments（具体路径在前）
    /^\/api\/attachments\/upload/,
    /^\/api\/attachments/,
    // home
    /^\/api\/home\/start/,
    // user
    /^\/api\/user\/settings\/ai_output_language/,
    /^\/api\/user\/drafting-plan/,
    /^\/api\/user\/init/,
    // chat（具体路径在前）
    /^\/api\/chat\/conversations\/get-mode/,
    /^\/api\/chat\/conversations/,
    /^\/api\/chat\/messages\/tasks\/[^/?]+/,
    /^\/api\/chat\/messages/,
    /^\/api\/chat\/suggestions/,
    // drafting ai-assist
    /^\/api\/drafting\/ai-assist/,
    // events
    /^\/api\/events\/stream\/[^/?]+/,
    // documents（具体路径在前）
    /^\/api\/documents\/by-project\/[^/?]+\/[^/?]+/,
    /^\/api\/documents\/[^/?]+\/contents\/save/,
    /^\/api\/documents\//,
    // patent
    /^\/api\/patent\/search-by-pn/,
];

function isFreeApiAllowed(url: string): boolean {
    // 提取 DRAFTING_URI 之后的路径部分进行匹配
    const path = url.slice(DRAFTING_URI.length);
    return FREE_API_PATTERNS.some(pattern => pattern.test(path));
}

export const initFreeUriInterceptor = () => {
    psAxios.interceptors.request.use((config) => {
        const isLoggedIn = headerService?.userCenterService?.logged;
        console.log('[freeUriInterceptor] isLoggedIn:', isLoggedIn);
        if (!isLoggedIn && config.url?.startsWith(DRAFTING_URI) && isFreeApiAllowed(config.url)) {
            config.url = FREE_DRAFTING_URI + config.url.slice(DRAFTING_URI.length);
        }
        return config;
    });
};
